export const isPlainObject = input => {
  return input && !Array.isArray(input) && typeof input === 'object';
};

export const deepCloneObject = obj => {
  return JSON.parse(JSON.stringify(obj));
};
